import Vue from "vue";
import Router from "vue-router";

import Home from "./views/Home.vue";
import Impressum from "./views/Impressum.vue";

import TaskCreate from "./views/TaskCreate.vue";
import TaskListUnsent from "./views/TaskListUnsent.vue";
import LogExplore from "./views/LogExplore.vue";

import UserAdmin from "./views/UserAdmin.vue";
import LogExploreAll from "./views/LogExploreAll.vue";

import TaskReceive from "./views/TaskReceive.vue";
import TaskReturn from "./views/TaskReturn.vue";

import { ability } from "@/ability";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/impressum",
      name: "impressum",
      component: Impressum,
      meta: { requiresNoLogin: true }
    },
    {
      path: "/auftrag-erstellen/:taskId?",
      name: "task-create-resume",
      component: TaskCreate,
      props: route => ({
        unsubmittedTaskId: route.params.taskId && parseInt(route.params.taskId)
      }),
      meta: { role: "rvkRhenusAdmin" }
    },
    {
      path: "/ungesendete-auftraege",
      name: "task-list-unsent",
      component: TaskListUnsent,
      meta: { role: "rvkRhenusAdmin" }
    },
    {
      path: "/protokoll-anzeigen",
      name: "log-explore",
      component: LogExplore,
      meta: { role: "rvkRhenusAdmin" }
    },
    {
      path: "/gesamtprotokoll-anzeigen",
      name: "log-explore-all",
      component: LogExploreAll,
      meta: { role: "rvkRhenusSuperUser" }
    },
    {
      path: "/auftrag-empfangen",
      name: "task-receive",
      component: TaskReceive,
      meta: { role: "rvkCustomerUser" }
    },
    {
      path: "/auftrag-zuruecksenden/:taskId?",
      name: "task-return",
      component: TaskReturn,
      props: route => ({
        unsubmittedTaskId: route.params.taskId && parseInt(route.params.taskId)
      }),
      meta: { role: "rvkCustomerUser" }
    },
    {
      path: "/benutzer-administrieren",
      name: "user-admin",
      component: UserAdmin,
      meta: { role: "rvkRhenusSuperUser" }
    }
  ]
});
